import { Avatar, Paper, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { EmploymentIcon, FromHeart, SocialHelp, Statoscope } from 'Images';

interface ICategory {
  mainCategory?: any;
  subCategory?: string;
}

export const Category = ({ mainCategory, subCategory }: ICategory) => {
  const isDesktop = useIsDesktop();

  const filterIcons = [FromHeart, Statoscope, SocialHelp, EmploymentIcon];

  return (
    <Paper
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        boxShadow: 'none',
        border: '1px solid rgba(23, 82, 175, 0.2)',
        borderRadius: '6px',
        padding: '8px',
        gap: '6px',
        width: 'fit-content',
      }}
    >
      {mainCategory && (
        <Avatar
          alt=''
          src={filterIcons[mainCategory?.id - 1]}
          sx={{
            width: isDesktop ? '32px' : '25px',
            height: isDesktop ? '30px' : '20px',
          }}
        />
      )}
      <Typography variant={'body6'} whiteSpace='nowrap'>
        {mainCategory?.name || ''}
      </Typography>
    </Paper>
  );
};
